import Modal from "../../../Framework/Components/Modals/Modal";
import {ModalType} from "../../../Framework/Components/Modals/ModalTypes";
import Button from "../../../Framework/Components/Buttons/Button";
import {ColourMod} from "../../../Framework/Data/Enums/LayoutEnums";
import {deleteUser, UserDataType, UsersUpdateType, useUpdateUsers} from "../../../Api/UsersEndpoints";
import {useState} from "react";

interface ConfirmDeleteUserType extends ModalType {
    user: UserDataType
}

const ConfirmDeleteUserModal = (props: ConfirmDeleteUserType) => {
    const updateUsers = useUpdateUsers();
    const [deletingUser, setDeletingUser] = useState<boolean>(false);

    const HandleDelete = async (userId: number) => {
        if(userId === -1) return;

        setDeletingUser(true);

        await deleteUser(userId).then((r) => {
            updateUsers.mutate({
                updateType: UsersUpdateType.REMOVE,
                newData: userId,
                forwardedFunction: null
            });

            props.closeCallback();
        }).catch((e) => {
            console.error(e.response.data);
        }).finally(() => setDeletingUser(false))
    }

    return (
        <Modal title={`Delete "${props.user?.name}"`} isOpen={props.isOpen} closeCallback={() => props.closeCallback()}>
            <p>This can not be undone, are you sure? </p>
            <Button
                title={'Delete'}
                loading={deletingUser}
                colour={ColourMod.Alert}
                fullWidth={true}
                onClick={() => HandleDelete(props.user?.userId ?? -1)}
            />
        </Modal>
    )
}

export default ConfirmDeleteUserModal